import React, {Component} from "react";
import Answer from "../../inputs/Answer";
import {FaAngleDoubleRight, FaStepBackward, FaStepForward} from "react-icons/fa";
import AnimatedSuccess from "./AnimatedSuccess";
import {getSectionAnswer} from "../../../common/section-questions/sections";
import LgShrink from "./LgShrink";

class Transition extends Component {
    state = {
        entered: false,
        position: this.props.forwards ? 'bottom' : 'top',
    }
    answerRef = React.createRef()
    transitionTimeout = null
    onLoaded = () => {
        clearTimeout(this.transitionTimeout)
        this.transitionTimeout = setTimeout(() => {
            this.addLastDelayEvent(() => {
                const r = this.answerRef.current.querySelector('input.form-control')
                if (r) {
                    r.focus()
                }
                this.setState({entered: true})
            })
            this.setState({position: ''})
        }, 50) // an timeout to prevent state merging
    }
    goBack = () => {
        clearTimeout(this.transitionTimeout)
        // console.log('action cleared, going back')
        // console.log('animating out')
        this.addLastDelayEvent(this.props.retreat)
        this.setState({position: 'bottom'})

    }
    goForward = () => {
        //make a blur forward clearable when back is clicked
        //console.log('(goForward action added)')
        clearTimeout(this.transitionTimeout)
        this.transitionTimeout = setTimeout(() => {
            this.addLastDelayEvent(this.props.advance)
            this.setState({position: 'top'})
        }, 100)

    }
    goForwardIfAnswered = () => {
        clearTimeout(this.transitionTimeout)
        if (this.props.question.answer.type === 'choice') {
            if (this.answerRef.current.querySelectorAll('input:checked').length > 0) {
                return this.goForward()
            }
        }
        if (this.props.question.answer?.optional) {
            return this.goForward()
        }
        if (!['', null, undefined].includes(getSectionAnswer(this.props.section, this.props.question))) {
            return this.goForward()
        }
    }
    handleSlideButtonClick = (e) => {
        if (this.props?.setAddRepeater && e.currentTarget.dataset?.repeater) {
            //flag the advance should create a new instance
            this.props.setAddRepeater()
        }
        this.goForward()
    }

    // onAnswered = (e) => {
    //     if (this.props.question.answer.type==='choice'){
    //         if (this.answerRef.current.querySelectorAll('input:checked').length > 0){
    //             this.onAnswered()
    //         }
    //     }
    //     // check that it wasn't the back btn that triggered this
    //     clearTimeout(this.transitionTimeout)
    //     this.transitionTimeout = setTimeout(() => {
    //         this.addLastDelayEvent(() => {
    //             if (e && e?.currentTarget && e.currentTarget.dataset?.add){
    //                 this.props.addRepeater()
    //             }
    //             else{
    //                 this.props.advance()
    //             }
    //
    //         })
    //         this.setState({position: 'top'})
    //     }, 50)
    // }
    addLastDelayEvent = (callback) => {
        const delays = this.answerRef.current.querySelectorAll('.transitionable');
        if (delays.length) {
            if (this.props.transitionName) {
                const lastOut = () => {
                    delays[delays.length - 1].removeEventListener(this.props.transitionName, lastOut, true)
                    callback()
                }
                delays[delays.length - 1].removeEventListener(this.props.transitionName, lastOut, true)
                delays[delays.length - 1].addEventListener(this.props.transitionName, lastOut, true)
            } else {
                const timeOut = (delays.length + 1) * 0.08
                setTimeout(() => {
                    callback()
                }, timeOut)
            }
        }

    }
    componentDidMount() {
        this.onLoaded();
    }

    render() {
        return (
            <>


                <div className="d-flex flex-column gap-5 mt-5">
                    <div ref={this.answerRef} className={`question-transition ${this.state.position}`}>
                        {this.props.question && (
                            <div className="d-flex align-items-start">
                                <button className={`btn btn-sm px-3`}
                                        onClick={this.goBack}><FaStepBackward/></button>
                                <div className="flex-fill">
                                    <LgShrink>
                                        <Answer
                                            autoFocus
                                            onAnswerSaved={this.props.question.answer.type === "multichoice" ? false : this.goForward}
                                            expandedStyle='wizard'
                                            editing={true}
                                            question={this.props.question}
                                            section={this.props.section}/>
                                    </LgShrink>
                                </div>
                                <button onClick={this.goForwardIfAnswered}
                                        className={`btn btn-sm px-3`}><FaStepForward/>
                                </button>
                            </div>

                        )}


                    </div>

                </div>

            </>
        )
    }
}

function TransitionSlide(props) {
    //console.log(props)
    const button = props?.repeater ? [
        <button key='yes' onClick={props.handleSlideClick} data-repeater={true}
                className={`btn btn-info btn-lg transitionable px-3 delay-3 me-3`}> Yes <FaAngleDoubleRight/></button>,
        <button key='no' onClick={props.handleSlideClick}
                className={`btn btn-success btn-lg text-white  transitionable px-3 delay-4`}> No <FaAngleDoubleRight/>
        </button>
    ] : <button key='ok' onClick={props.handleSlideClick}
                className={`btn btn-info btn-lg transitionable px-3 delay-3 me-3`}> Let's Go <FaAngleDoubleRight/>
    </button>

    const exclamations = ['Great Stuff', 'Well Done', 'Good Job', 'Nice', 'Excellent', 'Superb']
    const exclamation = props?.first ? '' : exclamations[props.random] + '! ';
    return (
        <div className="mt-5">
            {
                !props?.first && (
                    <div className="transitionable">
                        <AnimatedSuccess/>
                    </div>
                )
            }
            <h1 className="text-center mt-5 bold transitionable delay-1">{exclamation}{props.successText}</h1>
            <h4 className="text-muted mt-5 text-center transitionable delay-2">{props.instructionText}</h4>
            <div className="text-center mt-5">
                {button}
            </div>
        </div>
    )
}
export default Transition